import { Typography } from "@mui/material"
import { DataGrid, GridColDef } from "@mui/x-data-grid"
import { translate } from "app/language/service"
import { IDspDealFormat } from "dsp-deal/model"
import { IFormat } from "format/model"
import { getFormatByIds } from "format/tools/common"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { ListIdCell } from "ui/components/ListIdCell"
import { getDataGridTexts } from "ui/tools/list"

interface IDspDealFormatSummaryProps {
  formatAssociations: IDspDealFormat[]
  contentWidth: number
}

export const DspDealFormatSummary = React.memo(({ formatAssociations, contentWidth }: IDspDealFormatSummaryProps) => {
  const rows = getFormatByIds(formatAssociations.map(f => f.format_id))
  if (rows.length === 0) {
    return (
      <Typography id="summary-dsp-deal-media-format-empty" color="textSecondary" fontSize=".85rem" sx={{ ml: "1rem" }}>
        {translate("dsp-deal.formats.empty")}
      </Typography>
    )
  }
  if (contentWidth < 720) {
    return (
      <Typography id="summary-dsp-deal-media-format-count" color="textPrimary" fontSize=".85rem" sx={{ ml: "1rem" }}>
        {translate("dsp-deal.formats.count", rows.length)}
      </Typography>
    )
  }
  const columns: Array<GridColDef<IFormat>> = [
    {
      field: "name",
      headerName: translate("label.name"),
      flex: 3,
      renderCell: params => <ListIdCell label={params.row.name || "-"} id={params.row.id} />
    },
    {
      field: "width",
      headerName: translate("label.width"),
      flex: 2,
      renderCell: params => `${params.row.width} px`
    },
    {
      field: "height",
      headerName: translate("label.height"),
      flex: 2,
      renderCell: params => `${params.row.height} px`
    },
    {
      field: "orientation",
      headerName: translate("label.orientation"),
      flex: 1,
      renderCell: params => translate(`label.orientation.${params.row.orientation}`)
    }
  ]
  return (
    <FlexBox
      id="summary-dsp-deal-media-format-list"
      vertical
      fullWidth
      sx={{
        "minWidth": "100%",
        "maxWidth": "100%",
        "height": "15rem",
        "minHeight": "15rem",
        "maxHeight": "15rem",
        "transition": "all 400ms ease",
        "& > *": {
          width: "100%"
        },
        "& .MuiDataGrid-selectedRowCount": {
          visibility: "hidden"
        },
        "& .MuiDataGrid-root": {
          border: "none"
        },
        "& .MuiDataGrid-cell": {
          fontSize: ".8rem",
          fontWeight: 300
        },
        "& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus, & .MuiDataGrid-cell":
          {
            outline: "none !important"
          }
      }}>
      <DataGrid
        rows={rows}
        columns={columns}
        disableColumnFilter
        disableColumnMenu
        className="dsp-deal-summary-format-list"
        rowHeight={40}
        autoPageSize
        localeText={getDataGridTexts()}
      />
    </FlexBox>
  )
})
